const urlPage = window.location.href
let ENV_PROD = true

if (
  urlPage.includes('localhost') ||
  urlPage.includes('alpha') ||
  urlPage.includes('staging') ||
  urlPage.includes('uat')
) {
  ENV_PROD = false
}

module.exports = {
  REACT_APP_GOOGLE_API_KEY: 'AIzaSyAqjruSIzQF7pyM7-v0js0i4LbbLeGma-c',
  REACT_APP_GOOGLE_CAPTCHA_KEY: '6LfoQOAeAAAAAM6hRunsKleAX98D-WWpWBQtcWcs',
  REACT_GOOGLE_TAG_MANAGER: ENV_PROD ? 'GTM-W82WNX2' : (urlPage.includes('uat') ? 'GTM-PHQG9S34' : 'none'),
}